export { default } from "./DeleteContentIcon";
